






























import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import TabMenu from '@/components/common/TabMenu.vue';

@Component({
  components: { PageTitle, TabMenu, AdminIframe },
})

export default class CouponIssueIframe extends Vue {  
  private get remoteSrc() {
    // 프리미엄 원주소 : /promotion/coupon/list
    const query = this.$route.query;

    let detailPath = this.$route.meta.detailPath ?? '';

    if ('couponNo' in query && detailPath !== '/modify?') {
      detailPath = '/copy?'
    }

    const queryObject = { serviceType: 'PREMIUM', ...query };
    const queryString = new URLSearchParams(queryObject).toString();

    const paths = `/promotion/basic/coupons${detailPath || '?'}`

    return process.env.VUE_APP_ADMIN_REMOTE_URL + paths + queryString;
  }
}
